import React, { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { Moon, Sun } from 'lucide-react';
import { motion } from 'framer-motion';
import { useSpaceExperience } from './SpaceExperience';

const THEME_COLORS = {
  light: '#F4EDE4',
  dark: '#0F0C0A',
};

const ThemeToggle = ({ className = '' }) => {
  const space = useSpaceExperience();
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  useEffect(() => {
    if (!mounted || space) return;
    const mode = resolvedTheme === 'dark' ? 'dark' : 'light';
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', THEME_COLORS[mode]);
  }, [mounted, resolvedTheme, space]);

  if (!mounted) {
    return <span className={`theme-toggle ${className}`} aria-hidden="true" />;
  }

  const isDark = space ? space.mode === 'dark' : (resolvedTheme || theme) === 'dark';

  return (
    <motion.button
      type="button"
      className={`theme-toggle ${className}`}
      onClick={() => space ? space.setMode(isDark ? 'light' : 'dark') : setTheme(isDark ? 'light' : 'dark')}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
      data-testid="theme-toggle"
      whileTap={{ scale: 0.92 }}
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </motion.button>
  );
};

export default ThemeToggle;
